import React from 'react';
import { Accordion } from 'react-bootstrap';
import AsyncStbButton from '../../../../atoms/button/AsyncStbButton';
import { CheckCircleTwoTone } from '@ant-design/icons';
import RiskAssesmentContainerItem from '../../../../organisms/riskassesmentcontainer/RiskAssesmentContainerItem';
import { RiskAssesmentContainer } from '../../../../../api';

interface RiskAssesmentAccordionItemProps {
    riskAssesmentContainerData: RiskAssesmentContainer | undefined;
    riskAssesmentCompletionStatus: boolean;
    workerView: boolean;
    setRiskAssesmentContainerData: React.Dispatch<React.SetStateAction<RiskAssesmentContainer | undefined>>;
    onApprove: () => Promise<void>;
}

const RiskAssesmentAccordionItem: React.FC<RiskAssesmentAccordionItemProps> = ({
    riskAssesmentContainerData,
    riskAssesmentCompletionStatus,
    workerView,
    setRiskAssesmentContainerData,
    onApprove,
}) => {
    return (
        <>
            {riskAssesmentContainerData &&
                <Accordion.Item className='accordion-item shadow fw-bold' eventKey="5">
                    <Accordion.Header>Riskbedömning av arbetsmiljö
                        {riskAssesmentCompletionStatus && <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '25px', marginLeft: '10px' }} />}
                    </Accordion.Header>
                    <Accordion.Body>
                        <RiskAssesmentContainerItem
                            riskAssesmentContainer={riskAssesmentContainerData}
                            onUpdate={(updatedData) => {
                                setRiskAssesmentContainerData(updatedData);
                            }}
                            isWorkerView={workerView}
                        />
                        <div className="stb-action-bar">
                            <AsyncStbButton type="button" variant="primary" onClick={onApprove}>
                                Godkänn riskanalys
                            </AsyncStbButton>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            }
        </>
    );
};

export default RiskAssesmentAccordionItem;
